import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classes from './PreviewFile.module.css';
import IconButton from 'Components/Atoms/IconButtonBare';
import Icon from 'Components/Atoms/Icon/Icon';
import TextField from 'Components/Molecules/TextField/TextField';
import OutlinePrint from 'Components/Atoms/OutlineIcons/OutlinePrint';

const MIN_ZOOM = 0.1;
const MAX_ZOOM = 5;

export default function PreviewNav(props) {
    const { onDownload, page, onChangePage, zoom, onChangeZoom, numPages, onPrint } = props;

    const [pageNumberInput, setPageNumberInput] = useState(page.toString());

    useEffect(() => {
        setPageNumberInput(page.toString());
    }, [page]);

    const zoomIn = () => {
        const newZoom = Math.min(MAX_ZOOM, zoom + 0.5);
        onChangeZoom(newZoom);
    };

    const zoomOut = () => {
        const newZoom = Math.max(MIN_ZOOM, zoom - 0.5);
        onChangeZoom(newZoom);
    };

    const handleSubmitPage = (e) => {
        e.preventDefault();
        const pageNumberInput = Number(e.target.page.value);

        if (Number.isNaN(pageNumberInput)) {
            setPageNumberInput(page.toString());
            return;
        }
        if (pageNumberInput < 1) {
            onChangePage(1);
            return;
        }

        if (pageNumberInput > numPages) {
            onChangePage(numPages);
            return;
        }

        onChangePage(pageNumberInput);
    };

    return (
        <div className={classes.navbar}>
            <div className={classes.pagination}>
                <IconButton disabled={page <= 1} onClick={() => onChangePage(page - 1)}>
                    <Icon name="chevron-up" color="#222" size={24} />
                </IconButton>

                <form onSubmit={handleSubmitPage}>
                    <div className={classes.paginationInfo}>
                        <TextField
                            name="page"
                            type="text"
                            value={pageNumberInput}
                            className={classes.pageNumberInput}
                            onChange={(e) => setPageNumberInput(e.target.value)}
                        />
                        <div className={classes.pageNumberTotal}>/ {numPages}</div>
                    </div>
                </form>

                <IconButton onClick={() => onChangePage(page + 1)} disabled={page >= numPages}>
                    <Icon name="chevron-down" color="#222" size={24} />
                </IconButton>
            </div>

            <div className={classes.zoom}>
                <IconButton disabled={MIN_ZOOM === zoom} onClick={zoomOut}>
                    <span className={classes.zoomIcon}>-</span>
                </IconButton>

                <IconButton className={classes.zoomValue} onClick={() => onChangeZoom(1)}>
                    {(zoom * 100).toFixed()}%
                </IconButton>

                <IconButton disabled={MAX_ZOOM === zoom} onClick={zoomIn}>
                    <span className={classes.zoomIcon}> + </span>
                </IconButton>
            </div>

            <div className="flex items-center">
                {!!onDownload && (
                    <IconButton onClick={onDownload}>
                        <Icon name="download" color="#222" size={18} />
                    </IconButton>
                )}
                {!!onPrint && (
                    <IconButton onClick={onPrint}>
                        <OutlinePrint className="block" color="#222" size={22} />
                    </IconButton>
                )}
            </div>
        </div>
    );
}

PreviewNav.propTypes = {
    onDownload: PropTypes.func,
    onChangePage: PropTypes.func.isRequired,
    zoom: PropTypes.number.isRequired,
    onChangeZoom: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    numPages: PropTypes.number.isRequired,
    onPrint: PropTypes.func,
};
